import { Log } from '../log';
import { Service } from '../services/Service';

interface ConfigureOptions {
    wholesalerId?: number | null | string;
    fetchWholesalerId: () => number | null | string;
}

const logger = Log.channel('WholesalerService');

export class WholesalerService extends Service<WholesalerService>() {
    private currentWholesalerId: number | null | string;

    public setWholesalerId(wholesalerId: number | null) {
        this.currentWholesalerId = wholesalerId;
    }

    public getWholesalerId() {
        return this.currentWholesalerId;
    }

    /**
     * Configure service with all things we need.
     * @param options
     */
    public static configure(options: Partial<ConfigureOptions> = {}) {
        logger.debug('Configure');
        const service = this.instance;

        if (options.wholesalerId) {
            service.setWholesalerId(options.wholesalerId);
        } else if (options.fetchWholesalerId) {
            service.setWholesalerId(options.fetchWholesalerId());
        } else if (typeof document !== 'undefined') {
            service.setWholesalerId(service.getDocumentWholesalerId());
        }
    }

    public getDocumentWholesalerId() {
        const meta = document.querySelector<HTMLMetaElement>('meta[name=wholesaler_id]');
        return meta?.content;
    }
}
